import { OrderFields } from "../../../constants";
import type { TOrderFormData } from "../../../models/orderForm";
import type { TPrefillInfoParams } from "./types";

const getPrefillNewAddressData = ({ prefill, storedData }: TPrefillInfoParams): Partial<TOrderFormData> => {
  const receiverAddressId = prefill?.id ?? storedData?.[OrderFields.RECEIVER_ADDRESS_ID];
  const hasNewAddress = !receiverAddressId && storedData?.[OrderFields.HAS_NEW_ADDRESS];
  const name = storedData?.[OrderFields.NEW_ADDRESS_NAME];
  const phone = storedData?.[OrderFields.NEW_ADDRESS_PHONE];
  const email = storedData?.[OrderFields.NEW_ADDRESS_EMAIL];
  const locker = storedData?.[OrderFields.NEW_ADDRESS_LOCKER];
  const lockerName = storedData?.[OrderFields.NEW_ADDRESS_LOCKER_NAME];
  const street = storedData?.[OrderFields.NEW_ADDRESS_STREET];
  const houseNo = storedData?.[OrderFields.NEW_ADDRESS_HOUSE_NO];
  const flatNo = storedData?.[OrderFields.NEW_ADDRESS_FLAT_NO];
  const city = storedData?.[OrderFields.NEW_ADDRESS_CITY];
  const zipCode = storedData?.[OrderFields.NEW_ADDRESS_ZIP_CODE];

  const valuesToPrefill: Partial<TOrderFormData> = {
    [OrderFields.HAS_NEW_ADDRESS]: hasNewAddress,
    [OrderFields.NEW_ADDRESS_NAME]: name,
    [OrderFields.NEW_ADDRESS_PHONE]: phone,
    [OrderFields.NEW_ADDRESS_EMAIL]: email,
    [OrderFields.NEW_ADDRESS_LOCKER]: locker,
    [OrderFields.NEW_ADDRESS_LOCKER_NAME]: lockerName,
    [OrderFields.NEW_ADDRESS_STREET]: street,
    [OrderFields.NEW_ADDRESS_HOUSE_NO]: houseNo,
    [OrderFields.NEW_ADDRESS_FLAT_NO]: flatNo,
    [OrderFields.NEW_ADDRESS_CITY]: city,
    [OrderFields.NEW_ADDRESS_ZIP_CODE]: zipCode,
  };
  return valuesToPrefill;
};
export default getPrefillNewAddressData;
